import type { PortalView } from 'dfx/edge/edge.did';

export const isJoined = (portalView: PortalView, joined?: PortalView[]) => {
  if (!joined) {
    return false;
  }
  return joined.some((p) => p.slug === portalView.slug);
};
